import { RodapeTabelaRelatoriosComponent } from './pages/relatorios/rodape-tabela/rodape-tabela-relatorios/rodape-tabela-relatorios.component';
import { TabelaRelatorioComponent } from './pages/relatorios/tabela-relatorio/tabela-relatorio/tabela-relatorio.component';
import { RelatorioTaxaFixaEProducaoComponent } from './pages/relatorios/taxaFixaEProducao/relatorio-taxa-fixa-e-producao/relatorio-taxa-fixa-e-producao.component';
import { RelatorioFranquiaPorMaquinaComponent } from './pages/relatorios/franquiaPorMaquina/relatorio-franquia-por-maquina/relatorio-franquia-por-maquina.component';
import { RotuloCabecalhoComponent } from './pages/relatorios/rotulo-cabecalho/rotulo-cabecalho.component';
import { MensagemComponent } from './components/mensagem/mensagem.component';
import { BotaoResponderComponent } from './components/botao-responder/botao-responder.component';
import { MessageCardComponent } from './components/message-card/message-card.component';
import { DatailsCardComponent } from './components/datails-card/datails-card.component';
import { SuprimentosDetalhesDoPedidoComponent } from './pages/suprimentos/suprimentos-detalhes-do-pedido/suprimentos-detalhes-do-pedido.component';
import { BotoesFilesComponent } from './components/botoes-files/botoes-files.component';
import { HttpClientModule } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BotaoIncluirComponent } from './components/botao-incluir/botao-incluir.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';

import { ModalCadastrarUsuarioComponent } from './components/modal-cadastrar-usuario/modal-cadastrar-usuario.component';
import { MenuLateralComponent } from './components/menu-lateral/menu-lateral.component';
import { TabSuperiorComponent } from './components/tab-superior/tab-superior.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatFormFieldModule,
  MAT_FORM_FIELD_DEFAULT_OPTIONS
} from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { ToastComponent } from './components/toast/toast.component';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalEditarUsuarioComponent } from './components/modal-editar-usuario/modal-editar-usuario.component';
import { ModalExcluirUsuarioComponent } from './components/modal-excluir-usuario/modal-excluir-usuario.component';
import { GestaoDeAcessoComponent } from './pages/gestao-de-acesso/listar-usuario-acesso/gestao-de-acesso.component';
import { DocumentosComponent } from './pages/documentos/documentos.component';
import { ModalCadastrarPerfilComponent } from './components/modal-cadastrar-perfil/modal-cadastrar-perfil.component';
import { ListarPerfilAcessoComponent } from './pages/gestao-de-acesso/listar-perfil-acesso/listar-perfil-acesso.component';
import { ModalEditarPerfilComponent } from './components/modal-editar-perfil/modal-editar-perfil.component';
import { SidebarPermissoesComponent } from './components/sidebar-permissoes/sidebar-permissoes.component';
import { ModalExcluirPerfilComponent } from './components/modal-excluir-perfil/modal-excluir-perfil.component';
import { ListarFechamentoComponent } from './pages/financeiro/listar-fechamento/listar-fechamento.component';
import { ItemFinanceiroMobileComponent } from './components/item-financeiro-mobile/item-financeiro-mobile.component';
import { ListarBoletosComponent } from './pages/financeiro/listar-boletos/listar-boletos.component';
import { ItemBoletoMobileComponent } from './components/item-boleto-mobile/item-boleto-mobile.component';
import { ModalDownloadBoletoComponent } from './components/modal-download-boleto/modal-download-boleto.component';
import { ListagemInventarioComponent } from './pages/inventario/listagem-inventario/listagem-inventario.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ListagemInventarioDetalhesComponent } from './pages/inventario/listagem-inventario-detalhes/listagem-inventario-detalhes.component';
import { PageContainerComponent } from './components/page-container/page-container.component';
import { HeaderComponent } from './components/header/header.component';
import { BotaoVoltarComponent } from './components/botao-voltar/botao-voltar.component';
import { CardComponent } from './components/card/card.component';
import { BotaoSubmitComponent } from './components/botao-submit/botao-submit.component';
import { AbrirChamadoComponent } from './pages/servicos/abrir-chamado/abrir-chamado/abrir-chamado.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ListarContratosComponent } from './pages/listagem-de-contratos/listar-contratos/listar-contratos.component';
import { ListarContratoDetalhesComponent } from './pages/listagem-de-contratos/listar-contrato-detalhes/listar-contrato-detalhes.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ListagemDeOsVisaoDetalhadaComponent } from './pages/listagem-de-os/listagem-de-os-visao-detalhada/listagem-de-os-visao-detalhada.component';
import { ListarEquipamentosComponent } from './pages/servicos/listar-equipamentos/listar-equipamentos.component';
import { ListarHistoricoChamadosComponent } from './pages/servicos/listar-historico-chamados/listar-historico-chamados.component';
import { AbrirChamadoAComponent } from './pages/servicos/abrir-chamado/abrir-chamado-a/abrir-chamado-a.component';
import { AbrirChamadoBComponent } from './pages/servicos/abrir-chamado/abrir-chamado-b/abrir-chamado-b.component';
import { AbrirChamadoCComponent } from './pages/servicos/abrir-chamado/abrir-chamado-c/abrir-chamado-c.component';
import { AbrirChamadoDComponent } from './pages/servicos/abrir-chamado/abrir-chamado-d/abrir-chamado-d.component';
import { ListarEquipamentosDetalhesComponent } from './pages/servicos/listar-equipamentos-detalhes/listar-equipamentos-detalhes.component';
import { interceptorsProvider } from './interceptors';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { VisualizarPdfComponent } from './components/visualizar-pdf/visualizar-pdf.component';
import { ModalGeneralComponent } from './components/modal-general/modal-general.component';
import { NovoSuprimentoAComponent } from './pages/suprimentos/novo-suprimento-a/novo-suprimento-a.component';
import { NovoSuprimentoBComponent } from './pages/suprimentos/novo-suprimento-b/novo-suprimento-b.component';
import { NovoSuprimentoCComponent } from './pages/suprimentos/novo-suprimento-c/novo-suprimento-c.component';
import { NovoSuprimentoConclusionComponent } from './pages/suprimentos/novo-suprimento-conclusion/novo-suprimento-conclusion.component';
import { NovoSuprimentoComponent } from './pages/suprimentos/novo-suprimento/novo-suprimento.component';
import { SuprimentosHistoricoDePedidosComponent } from './pages/suprimentos/suprimentos-historico-de-pedidos/suprimentos-historico-de-pedidos.component';
import { SuprimentosHistoricoDePedidosEntregueComponent } from './pages/suprimentos/suprimentos-historico-de-pedidos-entregue/suprimentos-historico-de-pedidos-entregue.component';
import { TecnicoComponent } from './pages/tecnico/tecnico.component';
import { RedirecionarChamadoComponent } from './pages/redirecionar-chamado/redirecionar-chamado.component';
import { NovoSuprimentoKmDoBrasilAComponent } from './pages/suprimentos/novo-suprimento-km-do-brasil-a/novo-suprimento-km-do-brasil-a.component';
import { ParceiroComponent } from './pages/parceiro/parceiro.component';
import { ListarHistoricoChamadosFinalizadosComponent } from './pages/servicos/listar-historico-chamados-finalizados/listar-historico-chamados-finalizados.component';
import { SemAutorizacoesComponent } from './pages/sem-autorizacoes/sem-autorizacoes.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FiltroGenericoComponent } from './components/filtro-generico/filtro-generico.component';
import { GoBackDirective } from './directives/GoBack/GoBack.directive';
import { LoginComponent } from './pages/login/login.component';
import { LoginContainerComponent } from './pages/login-container/login-container.component';
import { RedefinirSenhaComponent } from './pages/redefinir-senha/redefinir-senha.component';
import { ConcluirRedefinirSenhaComponent } from './pages/concluir-redefinir-senha/concluir-redefinir-senha.component';
import { PaginacaoComponent } from './components/paginacao/paginacao.component';
import { NgxMaskModule } from 'ngx-mask';
import { IndicadorCircularPaginacaoComponent } from './components/indicador-circular-paginacao/indicador-circular-paginacao.component';
import { ModalAtivarOuDesativarUsuarioComponent } from './components/modal-ativar-ou-desativar-usuario/modal-ativar-ou-desativar-usuario.component';
import { MatInputModule } from '@angular/material/input';
import { TabelaComponent } from './components/tabela/tabela.component';
import { AlterarSenhaComponent } from './pages/alterar-senha/alterar-senha.component';
import { SelectAutoCompleteComponent } from './components/select-auto-complete/select-auto-complete.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DatePipe, registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { RelatorioExibidoComponent } from './components/relatorios/relatorio-exibido/relatorioExibido/relatorioExibido.component';
import { RelatorioInformaticaComponent } from './pages/relatorios/informatica/relatorio-informatica/relatorio-informatica.component';
import { CheckboxVisualizacaoColunaTabelaComponent } from './components/checkbox-visualizacao-coluna-tabela/checkbox-visualizacao-coluna-tabela.component';
import { InputPesquisarComponent } from './components/input-pesquisar/input-pesquisar.component';
import { SelectAllOptionsComponent } from './components/select-all-options/select-all-options.component';
import { ReciboComponent } from './components/recibo/recibo.component';
import { MensagemErroInputComponent } from './components/mensagem-erro-input/mensagem-erro-input.component';
import { CabecalhoRelatorioComponent } from './pages/relatorios/cabecalho/cabecalho-relatorio/cabecalho-relatorio.component';
import { RelatorioFranquiaGlobalComponent } from './pages/relatorios/franquiaGlobal/relatorio-franquia-global/relatorio-franquia-global.component';
import { ListarDemonstrativoFinanceiroComponent } from './pages/financeiro/listar-demonstrativo-financeiro/listar-demonstrativo-financeiro.component';
import { ListagemVaziaComponent } from './components/listagem-vazia/listagem-vazia.component';
import { RodapeRelatorioComponent } from './pages/relatorios/rodape-relatorio/rodape-relatorio/rodape-relatorio.component';
import { ListagemAcessoriosComponent } from './components/listagem-acessorios/listagem-acessorios.component';
import { ListagemEquipamentosSuprimentosComponent } from './components/listagem-equipamentos-suprimentos/listagem-equipamentos-suprimentos.component';
import { ModalEditarEquipamentoLocalizacaoComponent } from './components/modal-editar-equipamento-localizacao/modal-editar-equipamento-localizacao.component';

export function playerFactory() {
  return player;
}

registerLocaleData(ptBr);

@NgModule({
  declarations: [
    AppComponent,
    ToastComponent,
    TabSuperiorComponent,
    MenuLateralComponent,
    LoginComponent,
    DashboardComponent,
    DocumentosComponent,
    BotaoIncluirComponent,
    GestaoDeAcessoComponent,
    ModalCadastrarUsuarioComponent,
    ModalEditarUsuarioComponent,
    ModalExcluirUsuarioComponent,
    ModalAtivarOuDesativarUsuarioComponent,
    ListarPerfilAcessoComponent,
    ModalCadastrarPerfilComponent,
    ModalEditarPerfilComponent,
    ModalExcluirPerfilComponent,
    BotoesFilesComponent,
    ListarContratosComponent,
    ListarContratoDetalhesComponent,
    SidebarPermissoesComponent,
    ModalExcluirPerfilComponent,
    ListarBoletosComponent,
    ListarDemonstrativoFinanceiroComponent,
    ListarFechamentoComponent,
    ItemFinanceiroMobileComponent,
    ItemBoletoMobileComponent,
    ModalDownloadBoletoComponent,
    ModalExcluirPerfilComponent,
    ListagemInventarioComponent,
    PageNotFoundComponent,
    ListagemInventarioDetalhesComponent,
    PageContainerComponent,
    HeaderComponent,
    BotaoVoltarComponent,
    CardComponent,
    BotaoSubmitComponent,
    AbrirChamadoAComponent,
    AbrirChamadoBComponent,
    AbrirChamadoCComponent,
    AbrirChamadoDComponent,
    AbrirChamadoComponent,
    ListarEquipamentosComponent,
    ListarEquipamentosDetalhesComponent,
    ListarHistoricoChamadosComponent,
    ListagemDeOsVisaoDetalhadaComponent,
    VisualizarPdfComponent,
    NovoSuprimentoComponent,
    NovoSuprimentoAComponent,
    NovoSuprimentoBComponent,
    NovoSuprimentoCComponent,
    NovoSuprimentoConclusionComponent,
    SuprimentosHistoricoDePedidosComponent,
    SuprimentosHistoricoDePedidosEntregueComponent,
    ModalGeneralComponent,
    TecnicoComponent,
    RedirecionarChamadoComponent,
    SuprimentosDetalhesDoPedidoComponent,
    DatailsCardComponent,
    MessageCardComponent,
    BotaoResponderComponent,
    MensagemComponent,
    NovoSuprimentoKmDoBrasilAComponent,
    ParceiroComponent,
    ListarHistoricoChamadosFinalizadosComponent,
    SemAutorizacoesComponent,
    FiltroGenericoComponent,
    GoBackDirective,
    LoginContainerComponent,
    RedefinirSenhaComponent,
    ConcluirRedefinirSenhaComponent,
    PaginacaoComponent,
    IndicadorCircularPaginacaoComponent,
    TabelaComponent,
    AlterarSenhaComponent,
    SelectAutoCompleteComponent,
    RelatorioExibidoComponent,
    RelatorioInformaticaComponent,
    RelatorioFranquiaGlobalComponent,
    CheckboxVisualizacaoColunaTabelaComponent,
    InputPesquisarComponent,
    SelectAllOptionsComponent,
    ReciboComponent,
    RelatorioFranquiaPorMaquinaComponent,
    SelectAllOptionsComponent,
    CabecalhoRelatorioComponent,
    MensagemErroInputComponent,
    CabecalhoRelatorioComponent,
    RotuloCabecalhoComponent,
    RelatorioTaxaFixaEProducaoComponent,
    ListagemVaziaComponent,
    TabelaRelatorioComponent,
    RodapeTabelaRelatoriosComponent,
    RodapeRelatorioComponent,
    ListagemAcessoriosComponent,
    ListagemEquipamentosSuprimentosComponent,
    ModalEditarEquipamentoLocalizacaoComponent
  ],
  imports: [
    MatInputModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule,
    MatExpansionModule,
    MatCardModule,
    MatTooltipModule,
    MatMenuModule,
    ToastrModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    NgApexchartsModule,
    PdfViewerModule,
    LottieModule.forRoot({ player: playerFactory }),
    NgxMaskModule.forRoot(),
    MatAutocompleteModule
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' }
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: LOCALE_ID, useValue: 'pt' },
    interceptorsProvider,
    Title,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
